import { render, staticRenderFns } from "./ForHandle.vue?vue&type=template&id=99351d00&scoped=true&"
import script from "./ForHandle.vue?vue&type=script&lang=js&"
export * from "./ForHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99351d00",
  null
  
)

export default component.exports